import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EnumUserRole } from 'lib/graphql';
import { BaseModule } from 'lib/modules';

// Lazy-loaded page component
const ExportsPage = lazy(() =>
  import(/* webpackChunkName: "exports" */ 'pages/processor/exports').then(
    (m) => ({ default: m.default }),
  ),
);

/**
 * Exports Module Implementation
 */
class ExportsModuleClass extends BaseModule {
  id = 'EXPORTS';
  name = 'Exports';
  label = 'Data Exports';
  description = 'Data export and integration management';
  version = '1.0.0';
  /**
   * Creates route objects for the Exports module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    // Exports page
    routes.push({
      path: '/exports',
      element: (
        <RouteProtector
          component={ExportsPage}
          moduleId="EXPORTS"
          allowedUserRoles={[EnumUserRole.Vendor]}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const ExportsModule = new ExportsModuleClass();
